__turbopack_context__.v({
  "footer": "personal-plan-includes-modal-module-scss-module__CO8g3W__footer",
  "icon": "personal-plan-includes-modal-module-scss-module__CO8g3W__icon",
  "item": "personal-plan-includes-modal-module-scss-module__CO8g3W__item",
  "list": "personal-plan-includes-modal-module-scss-module__CO8g3W__list",
  "text": "personal-plan-includes-modal-module-scss-module__CO8g3W__text",
});
